import { DTO } from './dto/database';

const emailCollection = 'mail';
export const emailModel = new DTO(emailCollection);
